import { Divider } from "@mui/material";
import moment from "moment";
import { useSnackbar } from "notistack";
import React, { useState } from "react";
import { useNavigate } from "react-router";
import { ApiRequestPost } from "../../../../data/network/services/ApiRequestPost";
import {
  colorDarkBlue,
  colorDarkGreen,
  colorDarkRed,
  colorLightBlue,
  colorLightGreen,
  colorLightRed,
  primaryColor,
} from "../../../../utility/constants/colorManager";
import {
  APPROVE,
  PENDING,
  REJECT,
  STATUS_CODE_200,
} from "../../../../utility/constants/valueConstants";
import { CustomButton } from "../../main_comps/custom_button";
import CustomModal from "../../main_comps/custom_modal";
import RejectReasonModal from "../RejectReasonModal";
import ViewMoreApproval from "./ViewMoreApproval";

const mainTextStyle = {
  fontSize: 16,
  fontWeight: "600",
  color: primaryColor,
  margin: "5px 0px",
};

const subTextStyle = {
  color: "#6C6B6B",
  fontWeight: "600",
  fontSize: 15,
  margin: "5px 0px",
};

export const ClientDetialsForApproval = ({
  clientName,
  resellerName,
  onboardedTime,
  serviceType,
  serviceProvider,
  onBoarderedBy,
}) => {
  return (
    <div>
      <p style={mainTextStyle}>{clientName}</p>
      <p style={subTextStyle}>{resellerName}</p>
      <p
        style={{
          ...subTextStyle,
          fontSize: 13,
          color: "#7A7979",
          fontWeight: "400",
        }}
      >
        Onboard by - {onBoarderedBy} - {onboardedTime}
      </p>
      <p style={{ ...mainTextStyle, fontSize: 13 }}>
        Service Type : {serviceProvider}
      </p>
      <p style={{ ...mainTextStyle, fontSize: 13 }}>
        Service Provider : {serviceType}
      </p>
    </div>
  );
};

export const getAllServiceName = (res) => {
  let str = "";
  res?.map((data, i) => {
    if (i === 0) {
      str = data?.serviceProviderName;
    } else str = str + "," + data?.serviceProviderName;
  });
  return str;
};
function ApprovalContainer({
  showViewButton = true,
  isDividerRequired = true,
  data,
  onClose,
  id,
  isButtonsRequired = true,
  onSuccess,
}) {
  const [onClickViewMore, setOnClickViewMore] = useState("");
  const [onClickReject, setOnClickReject] = useState("");
  const { enqueueSnackbar } = useSnackbar();
  const [action, setAction] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const onClickApproveReject = (clientId, status, reason) => {
    setLoading(true);
    ApiRequestPost.adminApproveRejectAction({
      clientId,
      status,
      reason,
    })
      .then((response) => {
        if (response.statusCode === STATUS_CODE_200) {
          enqueueSnackbar(response.message, {
            variant: "success",
          });
          onSuccess();
        } else {
          enqueueSnackbar(response.message, {
            variant: "error",
          });
        }
        setLoading(false);
      })
      .catch((error) => {
        enqueueSnackbar(error.message, {
          variant: "error",
        });
        setLoading(false);
      });
  };

  return (
    <div
      style={{
        width: "100%",
        padding: "10px 10px",
        margin: "10px 0px",
      }}
      key={id}
    >
      <ClientDetialsForApproval
        clientName={data?.firstName + " " + data?.lastName}
        onboardedTime={moment(data["createdAt"]).format(
          "DD/MM/YYYY hh:mm:ss A"
        )}
        onBoarderedBy={data?.createdBy?.userName}
        resellerName={data?.resellerName}
        serviceProvider={
          data?.service?.length === 1
            ? data?.service[0]?.serviceType
            : "Payin & Payout"
        }
        serviceType={getAllServiceName(data?.service)}
      />

      {isButtonsRequired && (
        <div
          style={{
            display: "flex",
            justifyContent: !showViewButton ? "flex-start" : "space-between",
            margin: "15px 0px 20px 0px",
          }}
        >
          <CustomButton
            title="Reject"
            styles={{
              backgroundColor: colorLightRed,
              border: "none",
              margin: "0px 15px",
            }}
            textStyles={{
              color: colorDarkRed,
              fontWeight: "600",
            }}
            onClick={() => {
              setOnClickReject(true);
              setAction("REJECT");
            }}
            loading={action === "REJECT" && loading}
          />
          {showViewButton && (
            <CustomButton
              title="View"
              styles={{
                backgroundColor: colorLightBlue,
                border: "none",
              }}
              textStyles={{
                color: colorDarkBlue,
                fontWeight: "600",
                margin: "0px 15px",
              }}
              onClick={() => {
                navigate("/approval/list/details", {
                  state: {
                    clientData: data,
                    status: PENDING,
                  },
                });
                setOnClickViewMore(true);
              }}
            />
          )}
          <CustomButton
            title="Approve"
            styles={{
              backgroundColor: colorLightGreen,
              border: "none",
              marginLeft: !showViewButton ? 40 : 0,
            }}
            textStyles={{
              color: colorDarkGreen,
              fontWeight: "600",
            }}
            onClick={() => {
              setAction("APPROVE");

              onClickApproveReject(data?.userId, APPROVE);
            }}
            loading={action === "APPROVE" && loading}
          />
        </div>
      )}
      {isDividerRequired && <Divider />}

      {onClickViewMore && (
        <CustomModal
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "auto",
            maxHeight: 800,
          }}
          open={onClickViewMore}
          isBackRequired={false}
          isHeaderRequired={false}
          onClose={() => {
            setOnClickViewMore(false);
          }}
        >
          <ViewMoreApproval
            onClose={() => {
              setOnClickViewMore(false);
              onClose();
            }}
            data={data}
            onSuccess={onSuccess}
          />
        </CustomModal>
      )}

      {onClickReject && (
        <CustomModal
          containerStyle={{
            minWidth: 350,
            maxWidth: 450,
            height: "auto",
            maxHeight: 800,
          }}
          open={onClickReject}
          isBackRequired={false}
          isHeaderRequired={false}
          onClose={() => {
            setOnClickReject(false);
          }}
        >
          <RejectReasonModal
            onClickBack={() => {
              setOnClickReject(false);
            }}
            onClickOK={(reason) => {
              if (reason) {
                onClickApproveReject(data?.userId, REJECT, reason);
              } else {
                enqueueSnackbar("Please enter reason for Rejecting", {
                  variant: "error",
                });
              }
            }}
            loading={loading}
          />
        </CustomModal>
      )}
    </div>
  );
}

export default ApprovalContainer;
